import Axios from 'utils/axios';
import { put, call, select } from 'redux-saga/effects';
import * as Action from 'actions/Comments';

export function* onGetCommentsRequest({ payload: body = {}, cb }) {
  const params = {
    page: body.page || 0,
    size: 5,
    entityId: body.entityId,
    sort: body.sort ? body.sort : 'created,desc',
    entityType: body.entityType,
  };

  try {
    const { data } = yield Axios.get(`/api/comment/get`, { params });
    yield put(Action.onGetCommentsSuccess({ ...data, entityType: body.entityType, entityId: body.entityId }));
    cb && cb(null, data);
  } catch (e) {
    yield put(Action.onGetCommentsFailure({ ...params, message: e.toString() }));
    cb && cb(e);
  }
}

export function* onCreateCommentRequest({ payload: body = {}, cb }) {
  if (body.type === 'Reply') {
    yield call(onReplyRequest, { payload: body, cb });
  } else {
    const params = {
      content: body.content,
      entityId: body.entityId,
      entityType: body.entityType,
    };

    try {
      const { data } = yield Axios.post('/api/comment/create', params);
      yield put(Action.onCreateCommentSuccess({ ...data, parentEntityId: body.parentEntityId, parentEntityType: body.parentEntityType }));
      cb && cb(null, data);
    } catch (e) {
      yield put(Action.onCreateCommentFailure({ ...params, message: e.toString() }));
      cb && cb(e);
    }
  }
}

// export function* onReplyRequest({ payload: body = {}, cb }) {
//   const params = body;


//   try {
//     const { data } = yield Axios.post('/api/comment/comment/create', params);
//     // const student = yield select((state) => state.currentStudent.instance || {});
//     // data.student = ['id', 'studentId', 'lastName', 'firstName', 'pictureUrl', 'fullName'].reduce((obj, key) => ({ ...obj, [key]: student[key] }), {});
//     yield put(Action.onCreateCommentSuccess({ ...data, entityId: data.entityId, parentEntityType: body.parentEntityType, parentEntityId: body.parentEntityId }));
//     cb && cb(null, data);
//   } catch (e) {
//     yield put(Action.onCreateCommentFailure({ ...params, entityId: params.commentId, entityType: 'COMMENT', message: e.toString() }));
//     cb && cb(e);
//   }
// }

export function* onDeleteCommentRequest({ payload: body = {}, cb }) {
  try {
    const api = {
      body: { commentId: body.commentId },
      endpoint: 'api/comment/delete'
    };

    if (body.entityType === 'COMMENT') {
      api.body = { commentCommentId: body.commentId };
      api.endpoint = 'api/comment/comment/delete';
    }

    const { data } = yield Axios.post(api.endpoint, api.body);
    yield put(Action.onDeleteCommentSuccess(body));
    cb && cb(null, data);
  } catch (e) {
    yield put(Action.onDeleteCommentFailure({ message: e.toString() }));
    cb && cb(e);
  }
}